import { Icon, IconProps } from "./Icon";

export function IconTv(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M22.63 2H1.37A1.37 1.37 0 0 0 0 3.37v13.26A1.39 1.39 0 0 0 1.4 18h10.1v3H9v1h6v-1h-2.5v-3h10.13A1.36 1.36 0 0 0 24 16.63V3.37A1.37 1.37 0 0 0 22.63 2ZM23 16.63a.37.37 0 0 1-.37.36H1.4a.39.39 0 0 1-.4-.36V3.37A.38.38 0 0 1 1.37 3h21.26a.38.38 0 0 1 .37.37Z" />
    </Icon>
  );
}
